import { CartContext } from './context/CartContext';
import { IoIosCart } from 'react-icons/io';
import React, { useContext, useEffect, useRef } from 'react';
import '../styles/Cart.css';
import { bool } from 'prop-types';
import { useNavigate } from 'react-router-dom';

export default function Cart({ isMobile = false }) {
    const {
        cartState,
        showCartOverlay,
        setShowCartOverlay,
        setCartOverlayPosition,
    } = useContext(CartContext);
    const cartOverlayVisible = useRef(!!showCartOverlay);
    const cartRef = useRef(null);
    const navigate = useNavigate();

    const handleMobileCartClick = () => {
        navigate('/shoppingcart.asp');
        setShowCartOverlay(false);
    };

    const handleDesktopCartClick = (e) => {
        setShowCartOverlay((prev) => !prev);
        setCartOverlayPosition({
            x: e.pageX,
            y: e.pageY
        });
    };

    const handleSetShowCartOverLay = isMobile ? handleMobileCartClick : handleDesktopCartClick;
    useEffect(() => {
        if (!!showCartOverlay !== !!cartOverlayVisible.current) {
            cartOverlayVisible.current = !!showCartOverlay;
        }
    }, [showCartOverlay]);

    return (<div
        className={'cart-container'}>
        <button
            ref={cartRef}
            className={'cart-container-button'}
            aria-label={'Cart'}
            onClick={handleSetShowCartOverLay}>
            <IoIosCart
                className={'me-2'}
                size={'27px'}
                color={isMobile ? 'var(--primary-color)' : 'white'}
            />
            {isMobile ? <span>Cart</span> : null}
            <div
                className={'cart-counter'}>
                {cartState
                    ?.map((item) => item.quantity)
                    .reduce((prev, cur) => +prev + +cur, 0)
                    ?? 0}
            </div>
        </button>
    </div>);
}

Cart.propTypes = {
    isMobile: bool,
};
